import React from "react";

export const People = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M25.8732 24.394L20.7784 21.7889C20.2979 21.5429 19.9992 21.0487 19.9992 20.4989V18.6547C20.1213 18.502 20.2499 18.328 20.3827 18.136C21.0434 17.1815 21.573 16.1189 21.9581 14.9729C22.7106 14.62 23.1991 13.8591 23.1991 13V10.8182C23.1991 10.2929 23.0071 9.784 22.6658 9.38636V6.48509C22.6957 6.18509 22.813 4.39927 21.5501 2.926C20.4547 1.648 18.6771 1 16.2659 1C13.8548 1 12.0772 1.648 10.9817 2.92545C9.71884 4.39873 9.83617 6.18509 9.86603 6.48455V9.38582C9.52471 9.78345 9.33271 10.2924 9.33271 10.8176V12.9995C9.33271 13.6633 9.62764 14.2824 10.1311 14.6953C10.6196 16.6736 11.642 18.1644 11.9993 18.6427V20.4476C11.9993 20.9756 11.7177 21.46 11.2649 21.7131L6.50716 24.3673C4.96052 25.2302 4 26.8851 4 28.6873V31H28.5329V28.7947C28.5324 26.9195 27.5132 25.2329 25.8732 24.394Z" />
      </svg>
    </>
  );
};
export const Involvement = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_103_90)">
          <path d="M2.65973 24.394L7.75457 21.7889C8.2351 21.5429 8.53376 21.0487 8.53376 20.4989V18.6547C8.41163 18.502 8.2831 18.328 8.1503 18.136C7.48951 17.1815 6.95992 16.1189 6.57486 14.9729C5.82234 14.62 5.33381 13.8591 5.33381 13V10.8182C5.33381 10.2929 5.52581 9.784 5.86714 9.38636V6.48509C5.83727 6.18509 5.71994 4.39927 6.98285 2.926C8.0783 1.648 9.85587 1 12.267 1C14.6782 1 16.4558 1.648 17.5512 2.92545C18.8141 4.39873 18.6968 6.18509 18.6669 6.48455V9.38582C19.0083 9.78345 19.2002 10.2924 19.2002 10.8176V12.9995C19.2002 13.6633 18.9053 14.2824 18.4019 14.6953C17.9133 16.6736 16.891 18.1644 16.5336 18.6427V20.4476C16.5336 20.9756 16.8152 21.46 17.268 21.7131L22.0258 24.3673C23.5724 25.2302 24.533 26.8851 24.533 28.6873V31H3.62396e-05V28.7947C0.00056839 26.9195 1.01975 25.2329 2.65973 24.394Z" />
          <path d="M22.4092 23.6499L17.6514 20.9958C17.4557 20.8861 17.3336 20.6761 17.3336 20.4481V18.9132C17.8056 18.2412 18.6381 16.8885 19.1133 15.1441C19.6802 14.5812 20.0002 13.8148 20.0002 12.9999V10.8181C20.0002 10.205 19.8125 9.60775 19.4669 9.10484V6.52321C19.485 6.3143 19.5063 5.83102 19.4157 5.21684C20.1501 4.95502 20.9671 4.81812 21.8668 4.81812C27.4075 4.81812 27.7302 9.64812 27.7334 9.72721V12.2248C28.079 12.6099 28.2667 13.0545 28.2667 13.4958V15.3798C28.2667 15.9683 28.0091 16.517 27.5675 16.8879C27.1275 18.5843 26.0454 19.8661 25.6241 20.3161V21.8123C25.6241 22.2416 25.8524 22.6354 26.2486 22.8568L29.7968 25.133C31.1557 25.8912 32 27.3459 32 28.9288V30.9999H25.3334V28.6883C25.3334 26.5867 24.2129 24.6563 22.4092 23.6499Z" />
        </g>
        <defs>
          <clipPath id="clip0_103_90">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Search = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M29.6206 28.3252L22.4562 20.8992C24.2983 18.7169 25.3076 15.971 25.3076 13.1125C25.3076 6.43377 19.8553 1 13.1538 1C6.4523 1 1 6.43377 1 13.1125C1 19.7912 6.4523 25.225 13.1538 25.225C15.6696 25.225 18.0671 24.4687 20.1169 23.0331L27.3357 30.5155C27.6374 30.8278 28.0433 31 28.4782 31C28.8898 31 29.2803 30.8436 29.5768 30.5592C30.2066 29.9552 30.2267 28.9535 29.6206 28.3252ZM13.1538 4.15978C18.1073 4.15978 22.1371 8.17586 22.1371 13.1125C22.1371 18.0491 18.1073 22.0652 13.1538 22.0652C8.20034 22.0652 4.17056 18.0491 4.17056 13.1125C4.17056 8.17586 8.20034 4.15978 13.1538 4.15978Z" />
      </svg>
    </>
  );
};
export const CheckIn = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.66667 5.11111C4.80756 5.11111 4.11111 5.80756 4.11111 6.66667V25.3333C4.11111 26.1925 4.80756 26.8889 5.66667 26.8889H24.3333C25.1925 26.8889 25.8889 26.1925 25.8889 25.3333V16C25.8889 15.1409 26.5853 14.4444 27.4444 14.4444C28.3036 14.4444 29 15.1409 29 16V25.3333C29 27.9107 26.9107 30 24.3333 30H5.66667C3.08934 30 1 27.9107 1 25.3333V6.66667C1 4.08934 3.08934 2 5.66667 2H21.2222C22.0814 2 22.7778 2.69645 22.7778 3.55556C22.7778 4.41466 22.0814 5.11111 21.2222 5.11111H5.66667ZM27.9001 4.01116C28.5075 3.40369 29.4925 3.40369 30.0999 4.01116C30.7074 4.61865 30.7074 5.60357 30.0999 6.21106L16.0999 20.211C15.4925 20.8185 14.5075 20.8185 13.9001 20.211L9.23338 15.5444C8.62591 14.9369 8.62591 13.952 9.23338 13.3445C9.84087 12.737 10.8258 12.737 11.4333 13.3445L15 16.9112L27.9001 4.01116Z"
        />
      </svg>
    </>
  );
};
export const Registration = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.7924 0H9.32869C8.04016 0 7 1.04482 7 2.33103V29.6713C7 30.9563 8.04016 32 9.32869 32H22.7924C24.0786 32 25.1211 30.9563 25.1211 29.6713V2.33103C25.1211 1.04482 24.0786 0 22.7924 0ZM12.7384 1.41564H19.3851C19.553 1.41564 19.6895 1.66635 19.6895 1.97653C19.6895 2.28671 19.553 2.53859 19.3851 2.53859H12.7384C12.5693 2.53859 12.4352 2.28671 12.4352 1.97653C12.4352 1.66635 12.5693 1.41564 12.7384 1.41564ZM16.0617 29.6993C15.242 29.6993 14.575 29.0323 14.575 28.2114C14.575 27.3904 15.242 26.7257 16.0617 26.7257C16.8792 26.7257 17.5462 27.3904 17.5462 28.2114C17.5462 29.0323 16.8792 29.6993 16.0617 29.6993ZM23.3767 24.6046H8.74565V3.93324H23.3767V24.6046Z" />
      </svg>
    </>
  );
};
export const Finance = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_103_180)">
          <path d="M24.7428 21.9319C24.7614 19.4003 23.7606 17.3981 21.7645 15.9841C20.2227 14.8955 18.3517 14.3276 16.5421 13.7819C12.7724 12.6391 11.6788 12.0371 11.6788 10.2344C11.6788 8.22636 14.2884 7.51189 16.5225 7.51189C18.1495 7.51189 20.0213 8.01775 21.1838 8.76742L23.4884 5.19819C21.9691 4.21328 19.8898 3.54148 17.8365 3.33296V0H13.5852V3.56668C9.80614 4.39801 7.42552 6.86793 7.42552 10.2344C7.42552 12.5921 8.40524 14.4618 10.3319 15.7806C11.7973 16.7874 13.5845 17.328 15.3108 17.8514C19.0084 18.9691 20.51 19.6501 20.4929 21.9056L20.4928 21.9222C20.4928 23.8153 17.9841 24.4882 15.8348 24.4882C13.8046 24.4882 11.5968 23.5984 10.3453 22.2755L7.25684 25.1969C8.84171 26.8732 11.1444 28.0583 13.5851 28.5228V32.0001H17.8365V28.5977C22.0358 27.9966 24.7386 25.4684 24.7428 21.9319Z" />
        </g>
        <defs>
          <clipPath id="clip0_103_180">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Email = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M29.1427 28.5715C29.862 28.5715 30.4853 28.3339 31.0152 27.865L21.9491 18.7985C21.7315 18.9543 21.5207 19.1057 21.3215 19.2498C20.6431 19.7496 20.0924 20.1397 19.6696 20.4192C19.2468 20.6994 18.6843 20.9849 17.9821 21.2765C17.2795 21.5683 16.6249 21.7138 16.0177 21.7138H15.9999H15.9821C15.3748 21.7138 14.7202 21.5684 14.0176 21.2765C13.3151 20.9849 12.7526 20.6994 12.3302 20.4192C11.9074 20.1397 11.3571 19.7497 10.6782 19.2498C10.4891 19.1111 10.2793 18.9589 10.0525 18.7961L0.984619 27.865C1.51441 28.3339 2.13809 28.5715 2.85735 28.5715H29.1427Z" />
        <path d="M1.80376 13.0894C1.12536 12.6371 0.523752 12.1191 0 11.5356V25.3295L7.99083 17.3387C6.39221 16.2226 4.33247 14.8078 1.80376 13.0894Z" />
        <path d="M30.2144 13.0894C27.7821 14.7357 25.7149 16.1529 24.0125 17.3419L32.0001 25.3299V11.5356C31.488 12.1074 30.8928 12.625 30.2144 13.0894Z" />
        <path d="M29.1425 3.42853H2.85721C1.94019 3.42853 1.23517 3.73819 0.741282 4.35687C0.246986 4.97585 0.000244141 5.74994 0.000244141 6.67829C0.000244141 7.42816 0.327684 8.24066 0.982272 9.11602C1.63686 9.99103 2.3334 10.6783 3.07153 11.1783C3.47618 11.4642 4.69647 12.3125 6.73239 13.723C7.83143 14.4846 8.78719 15.1484 9.60852 15.7213C10.3086 16.2091 10.9124 16.6315 11.4108 16.9821C11.4681 17.0222 11.5581 17.0866 11.6775 17.172C11.8062 17.2644 11.969 17.3817 12.1699 17.5268C12.5568 17.8066 12.8782 18.0328 13.1342 18.2055C13.3898 18.3784 13.6995 18.5714 14.0629 18.7858C14.4259 18.9999 14.7684 19.1609 15.0898 19.268C15.4112 19.375 15.7088 19.4287 15.9826 19.4287H16.0003H16.0181C16.2918 19.4287 16.5894 19.375 16.911 19.268C17.2323 19.1609 17.5744 19.0003 17.9378 18.7858C18.3008 18.5714 18.6101 18.378 18.8665 18.2055C19.1225 18.0328 19.4439 17.8066 19.8308 17.5268C20.0313 17.3817 20.1942 17.2644 20.3229 17.1723C20.4424 17.0865 20.5323 17.0226 20.5899 16.9821C20.9782 16.7118 21.5834 16.2912 22.397 15.7262C23.8774 14.6976 26.0577 13.1836 28.947 11.1783C29.816 10.5713 30.542 9.83887 31.1255 8.98198C31.7079 8.1251 31.9999 7.22627 31.9999 6.28578C31.9999 5.50001 31.7168 4.82764 31.1518 4.26763C30.5861 3.70833 29.9163 3.42853 29.1425 3.42853Z" />
      </svg>
    </>
  );
};
export const Administration = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_103_260)">
          <path d="M17.0638 10.8871V8.61192L14.13 7.96009C14.0299 7.64726 13.9025 7.3473 13.7538 7.0595L15.3692 4.52078L13.7602 2.91187L11.2215 4.52725C10.9337 4.37858 10.6337 4.25122 10.3209 4.15107L9.66951 1.21759H7.39433L6.7425 4.1514C6.42967 4.2515 6.12971 4.37892 5.84191 4.52759L3.30319 2.91226L1.69423 4.52117L3.3096 7.05989C3.16094 7.34769 3.03352 7.64765 2.93342 7.96048L0 8.61192V10.8871L2.93387 11.5389C3.03396 11.8518 3.16138 12.1517 3.31005 12.4395L1.69467 14.9782L3.30364 16.5871L5.84236 14.9718C6.13016 15.1204 6.43011 15.2478 6.74295 15.348L7.39444 18.2814H9.66962L10.3214 15.3476C10.6343 15.2475 10.9342 15.12 11.222 14.9714L13.7608 16.5868L15.3697 14.9778L13.7543 12.4391C13.903 12.1513 14.0304 11.8514 14.1305 11.5385L17.0638 10.8871ZM8.53192 12.5935C6.96127 12.5935 5.68795 11.3202 5.68795 9.74951C5.68795 8.17886 6.96127 6.90554 8.53192 6.90554C10.1026 6.90554 11.3759 8.17886 11.3759 9.74951C11.3759 11.3202 10.1026 12.5935 8.53192 12.5935ZM20.7315 27.4208L21.4485 25.6697L19.3956 24.2432C19.4172 23.9709 19.4134 23.6998 19.3898 23.4317L21.4334 21.9866L20.7019 20.2412L18.2386 20.6848C18.0638 20.48 17.8734 20.287 17.6641 20.1114L18.0869 17.6478L16.3358 16.9308L14.9093 18.9837C14.637 18.9621 14.3659 18.9659 14.0978 18.9894L12.6527 16.9459L10.9073 17.6773L11.3509 20.1406C11.1461 20.3154 10.9531 20.5058 10.7775 20.7151L8.31388 20.2923L7.59687 22.0435L9.64983 23.47C9.62819 23.7423 9.63198 24.0133 9.65551 24.2814L7.61203 25.7266L8.34349 27.472L10.8067 27.0284C10.9815 27.2331 11.1719 27.4261 11.3812 27.6017L10.9584 30.0654L12.7095 30.7824L14.1361 28.7295C14.4083 28.7511 14.6795 28.7473 14.9475 28.7237L16.3927 30.7673L18.1381 30.0358L17.6945 27.5725C17.8992 27.3981 18.0922 27.2073 18.2678 26.998L20.7315 27.4208ZM13.626 26.0455C12.4172 25.5506 11.8381 24.1692 12.333 22.96C12.8278 21.7507 14.2092 21.1721 15.4185 21.6669C16.6274 22.1618 17.2064 23.5432 16.7116 24.7525C16.2167 25.9617 14.8353 26.5407 13.626 26.0455ZM32.0001 9.29107L31.3967 7.43073L28.8247 7.6757C28.6601 7.44628 28.4758 7.2351 28.2782 7.03904L28.9259 4.53483L27.1835 3.64601L25.5359 5.64019C25.2613 5.59508 24.9822 5.57004 24.6997 5.57155L23.3884 3.34527L21.5282 3.94859L21.7731 6.52065C21.5437 6.68521 21.3325 6.86951 21.1365 7.06709L18.6323 6.41944L17.7434 8.16185L19.7376 9.80946C19.6925 10.084 19.6675 10.3631 19.669 10.6456L17.443 11.9564L18.0464 13.8168L20.6184 13.5718C20.783 13.8012 20.9669 14.0124 21.1649 14.2085L20.5172 16.7127L22.2596 17.6015L23.9072 15.6073C24.1817 15.6524 24.4608 15.6775 24.7433 15.6759L26.0546 17.9022L27.9149 17.2989L27.67 14.7268C27.8994 14.5622 28.1106 14.3779 28.3066 14.1804L30.8108 14.828L31.6997 13.0856L29.7054 11.438C29.7506 11.1635 29.7756 10.8844 29.7741 10.6019L32.0001 9.29107ZM25.476 12.9492C24.1916 13.3659 22.8125 12.6621 22.3961 11.3778C21.9794 10.0935 22.6832 8.7143 23.9676 8.29797C25.2519 7.88124 26.6311 8.58504 27.0474 9.86935C27.4637 11.1537 26.7603 12.5328 25.476 12.9492Z" />
        </g>
        <defs>
          <clipPath id="clip0_103_260">
            <rect width="32.0001" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ToolBar = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.985 10.813C15.429 10.822 14.986 11.275 14.997 11.832V19.414L13.874 18.291C13.686 18.098 13.43 17.989 13.159 17.988C12.606 17.987 12.158 18.433 12.157 18.986C12.157 19.257 12.267 19.518 12.464 19.709L15.292 22.537C15.684 22.925 16.313 22.925 16.702 22.537L19.536 19.709C19.919 19.31 19.906 18.675 19.507 18.292C19.119 17.921 18.508 17.92 18.12 18.291L16.997 19.418V11.832C17.008 11.267 16.549 10.807 15.985 10.813ZM31 21.325C31 24.348 28.535 26.815 25.516 26.815C19.543 26.815 13.572 26.815 7.6 26.815C3.958 26.815 1 23.849 1 20.203C1 16.932 3.493 14.455 6.609 13.928C6.916 9.214 10.56 5.583 15.926 5.185C21.506 5.583 25.471 9.46 25.471 14.471C25.47 14.934 25.346 15.379 25.397 15.833C28.536 15.833 31 18.3 31 21.325Z" />
      </svg>
    </>
  );
};
export const Copy = ({ handleClick, data, index  }) => {
  return (
    <>
      <svg
        width="32"
        height="32"
        onClick={() => handleClick(data, index)}
        className="cursor-pointer mr-2"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_218_399"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="5"
          width="22"
          height="22"
        >
          <path d="M27 5H5V27H27V5Z" />
        </mask>
        <g mask="url(#mask0_218_399)">
          <path d="M13.2498 5.91666H23.3332C24.3415 5.91666 25.1665 6.74166 25.1665 7.74999V19.6667C25.1665 20.1708 24.754 20.5833 24.2498 20.5833C23.7457 20.5833 23.3332 20.1708 23.3332 19.6667V8.66666C23.3332 8.16249 22.9207 7.74999 22.4165 7.74999H13.2498C12.7457 7.74999 12.3332 7.33749 12.3332 6.83332C12.3332 6.32916 12.7457 5.91666 13.2498 5.91666ZM9.58317 9.58332H19.6665C20.6748 9.58332 21.4998 10.4083 21.4998 11.4167V24.25C21.4998 25.2583 20.6748 26.0833 19.6665 26.0833H9.58317C8.57484 26.0833 7.74984 25.2583 7.74984 24.25V11.4167C7.74984 10.4083 8.57484 9.58332 9.58317 9.58332ZM10.4998 24.25H18.7498C19.254 24.25 19.6665 23.8375 19.6665 23.3333V12.3333C19.6665 11.8292 19.254 11.4167 18.7498 11.4167H10.4998C9.99567 11.4167 9.58317 11.8292 9.58317 12.3333V23.3333C9.58317 23.8375 9.99567 24.25 10.4998 24.25Z" />
        </g>
      </svg>
    </>
  );
};
export const Share = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        className="cursor-pointer"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_218_412)">
          <path d="M24.5284 9.33328C24.5284 10.8291 23.3159 12.0417 21.8201 12.0417C20.3243 12.0417 19.1118 10.8291 19.1118 9.33328C19.1118 7.83762 20.3243 6.625 21.8201 6.625C23.3159 6.625 24.5284 7.83762 24.5284 9.33328Z" />
          <path d="M21.8201 12.6667C19.9817 12.6667 18.4868 11.1717 18.4868 9.33328C18.4868 7.49506 19.9817 6 21.8201 6C23.6585 6 25.1534 7.49506 25.1534 9.33328C25.1534 11.1717 23.6585 12.6667 21.8201 12.6667ZM21.8201 7.25C20.671 7.25 19.7368 8.18506 19.7368 9.33328C19.7368 10.4817 20.671 11.4167 21.8201 11.4167C22.9692 11.4167 23.9034 10.4817 23.9034 9.33328C23.9034 8.18506 22.9692 7.25 21.8201 7.25Z" />
          <path d="M24.5284 22.6667C24.5284 24.1624 23.3159 25.375 21.8201 25.375C20.3243 25.375 19.1118 24.1624 19.1118 22.6667C19.1118 21.1709 20.3243 19.9583 21.8201 19.9583C23.3159 19.9583 24.5284 21.1709 24.5284 22.6667Z" />
          <path d="M21.8201 26C19.9817 26 18.4868 24.5049 18.4868 22.6667C18.4868 20.8283 19.9817 19.3333 21.8201 19.3333C23.6585 19.3333 25.1534 20.8283 25.1534 22.6667C25.1534 24.5049 23.6585 26 21.8201 26ZM21.8201 20.5833C20.671 20.5833 19.7368 21.5183 19.7368 22.6667C19.7368 23.8149 20.671 24.75 21.8201 24.75C22.9692 24.75 23.9034 23.8149 23.9034 22.6667C23.9034 21.5183 22.9692 20.5833 21.8201 20.5833Z" />
          <path d="M12.862 16C12.862 17.4958 11.6494 18.7083 10.1536 18.7083C8.65793 18.7083 7.44531 17.4958 7.44531 16C7.44531 14.5042 8.65793 13.2917 10.1536 13.2917C11.6494 13.2917 12.862 14.5042 12.862 16Z" />
          <path d="M10.1536 19.3333C8.31537 19.3333 6.82031 17.8384 6.82031 16C6.82031 14.1616 8.31537 12.6667 10.1536 12.6667C11.992 12.6667 13.487 14.1616 13.487 16C13.487 17.8384 11.992 19.3333 10.1536 19.3333ZM10.1536 13.9167C9.00446 13.9167 8.07031 14.8516 8.07031 16C8.07031 17.1484 9.00446 18.0833 10.1536 18.0833C11.3029 18.0833 12.237 17.1484 12.237 16C12.237 14.8516 11.3029 13.9167 10.1536 13.9167Z" />
          <path d="M12.1213 15.6001C11.8312 15.6001 11.5495 15.4492 11.3962 15.1792C11.1687 14.7801 11.3087 14.2709 11.7079 14.0425L19.4403 9.63419C19.8395 9.40501 20.3487 9.54508 20.5771 9.94578C20.8046 10.3449 20.6645 10.8541 20.2653 11.0826L12.5328 15.4908C12.4028 15.565 12.2612 15.6001 12.1213 15.6001Z" />
          <path d="M19.853 22.4751C19.7129 22.4751 19.5713 22.44 19.4413 22.3658L11.7088 17.9575C11.3096 17.73 11.1697 17.2209 11.3972 16.8208C11.6238 16.4208 12.1337 16.28 12.5338 16.5092L20.2664 20.9174C20.6655 21.145 20.8055 21.6541 20.5779 22.0542C20.4238 22.3242 20.1422 22.4751 19.853 22.4751Z" />
        </g>
        <defs>
          <clipPath id="clip0_218_412">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Flag = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        className="cursor-pointer mx-[6px]"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.58333 25.7917C8.125 25.7917 7.75 25.4167 7.75 24.9583V8.49999C7.75 8.04166 8.125 7.66666 8.58333 7.66666C9.04167 7.66666 9.41667 8.04166 9.41667 8.49999V24.9583C9.375 25.4167 9.04167 25.7917 8.58333 25.7917Z" />
        <path d="M11.7083 19.8333C10.3333 19.8333 9.16667 19.375 8.04167 18.375C7.875 18.2083 7.75 18 7.75 17.75V8.29166C7.75 7.95832 7.95833 7.66666 8.25 7.54166C8.54167 7.41666 8.875 7.45832 9.125 7.66666C9.95833 8.37499 10.75 8.70832 11.7083 8.70832C12.9583 8.70832 14.2917 8.12499 15.6667 7.49999C17.1667 6.83332 18.6667 6.16666 20.2917 6.16666C21.6667 6.16666 22.8333 6.62499 23.9583 7.62499C24.125 7.79166 24.25 7.99999 24.25 8.24999V17.7083C24.25 18.0417 24.0417 18.3333 23.75 18.4583C23.4583 18.5833 23.125 18.5417 22.875 18.3333C22.0417 17.625 21.25 17.2917 20.2917 17.2917C19.0417 17.2917 17.7083 17.875 16.3333 18.5C14.8333 19.125 13.2917 19.7917 11.7083 19.8333ZM9.375 17.375C10.0833 17.9167 10.8333 18.2083 11.7083 18.2083C12.9583 18.2083 14.2917 17.625 15.6667 17C17.1667 16.3333 18.6667 15.6667 20.2917 15.6667C21.125 15.6667 21.875 15.8333 22.625 16.2083V8.66666C21.9167 8.12499 21.1667 7.83332 20.2917 7.83332C19.0417 7.83332 17.7083 8.41666 16.3333 9.04166C14.8333 9.70832 13.3333 10.375 11.7083 10.375C10.875 10.375 10.125 10.2083 9.375 9.83332V17.375Z" />
      </svg>
    </>
  );
};
export const SearchIcon = () => {
  return (
    <>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        className="absolute right-[12px] top-[21px]"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_14_5145)">
          <path
            d="M17.4249 16.8951L13.1409 12.4395C14.2424 11.1301 14.8459 9.48262 14.8459 7.76749C14.8459 3.76026 11.5856 0.5 7.57841 0.5C3.57117 0.5 0.310913 3.76026 0.310913 7.76749C0.310913 11.7747 3.57117 15.035 7.57841 15.035C9.08278 15.035 10.5164 14.5812 11.742 13.7199L16.0586 18.2093C16.239 18.3967 16.4817 18.5 16.7418 18.5C16.9879 18.5 17.2214 18.4062 17.3987 18.2355C17.7753 17.8731 17.7873 17.2721 17.4249 16.8951ZM7.57841 2.39587C10.5404 2.39587 12.95 4.80552 12.95 7.76749C12.95 10.7295 10.5404 13.1391 7.57841 13.1391C4.61643 13.1391 2.20678 10.7295 2.20678 7.76749C2.20678 4.80552 4.61643 2.39587 7.57841 2.39587Z"
            fill="#444444"
          />
        </g>
        <defs>
          <clipPath id="clip0_14_5145">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
